module.exports = __webpack_public_path__ + "static/media/pentadata_logo_only.16160241.png";